import React, { useEffect, useReducer, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Customer from "./customer/Customer";
import ProtectedRoute from "../utils/ProtectedRoute";
import AddCustomer from "./customer/AddCustomer";
import AddCompany from "./company/AddCompany";
import AddCustomer1 from "./customer/AddCustomer1";
import Importcha from "./chartofaccount/Importcha";
import AssetList from "./chartofaccount/AssetList";
import Page from "./FpoUSA/Page";
import DashboardMain from "./Dashboard/DashboardMain";
import EditCompany from "./company/EditCompany";
import SignupForm from "./SignupForm";
import AddVendor from "./Vendor/AddVendor";
// import AddVendor from "./company/AddVendor";
import TaskPod from "./TaskPod/TaskPod";
import Invoice from "./customer/Invoice";
import UserPage from "./User/UserPage";
import ManageList from "./User/ManageList";
import DynamicListTable from "./User/DynamicListTable";
import AddOrganization from "./Organization/AddOrganization";
import ModalCompany from "./company/ModalCompany";
import ManagePermission from "./Permission/ManagePermission";
import CompanyDelegation from "./company/CompanyDelegation";
import VendorList from "./Vendor/VendorList";
import VendorDashboard from "./Vendor/VendorDashboard";
import BankTransfer from "./Vendor/BankTransfer";
import UserProfileDetails from "./User/UserProfileDetails";
import Notification from "./userProfile/Notification";
import UserProfileView from "./User/UserProfileView";
import InvoiceView from "./customer/InvoiceView";
import ForgetPass from "./ForgetPass";
import ResetPassword from "./ResetPassword";
import CustomerManagePermission from "./customer/CustomerManagePermission";
import CompanyManagePermission from "./CompanyAndPermission/Page";
import AllTasks from "./Task/AllTasks";
import CoaForms from "./chartofaccount/CoaForms";
import Checks from "./Vendor/Checks";
import PayBills from "./Vendor/PayBills";
import PurchaseOrder from "./Vendor/PurchaseOrder";
import VendorCredit from "./Vendor/VendorCredit";
import CreditCardCredit from "./Vendor/CreditCardCredit";
import VendorAdd from "./Vendor/VendorAdd";
import PrintChecks from "./Vendor/PrintChecks";
import Bills from "./Vendor/Bills";
import ReceivePayment from "./CustomerNew/ReceivePayment";
import InvoiceNew from "./CustomerNew/InvoiceNew";
import Statement from "./CustomerNew/Statement";
import Estimate from "./CustomerNew/Estimate";
import CreditMemo from "./CustomerNew/CreditMemo";
import SalesReceipt from "./CustomerNew/SalesReceipt";
import ShippingLabel from "./CustomerNew/ShippingLabel";
import RefundReceipt from "./CustomerNew/RefundReceipt";
import DelayedCharge from "./CustomerNew/DelayedCharge";
import DelayedCredit from "./CustomerNew/DelayedCredit";
import AddClient from "./CustomerNew/AddClient";
import Expense from "./Vendor/Expense";
import JournalEntry from "./OtherLeftMenu/JournalEntry";
import FirstMessage from "./GlobalFeature/MessageAlert/FirstMessage";
import { pushAlert } from "../utils/alertSlice";
import { useDispatch, useSelector } from "react-redux";
import DynamicVoucherForm from "./Vendor/DynamicVoucher";
import Loader from "./UniversalComponents/Loader";
import PageNotFound from "./PageNotFound";
import VendorDynamicPage from "./Vendor/VendorDynamicPage";
import SpecificCustomer from "./customer/SpecificCustomer";
import GroupDashboard from "./Groups/StatusCompletionComponent";
import AutofillBill from "./Vendor/AutofillBill";
import { showLoader } from "../utils/loaderSlice";
import MySpace from "./mySpace/Page";
import TaskTable from "./TaskPod/AllTasksTanStack";
import PersonSelect from "./UniversalComponents/PersonSelect";
import MockPage from "./MockPage";
import RevampledAllTask from "./Task/RevampedAllTask";
import DashBoardFunnel from "./Dashboard/DashBoardFunnel";

import Test from "./Dashboard/Test";

import Vendor from "./Vendor/Vendor";
import CreateTemplate from "./Template/CreateTemplate";
import CustomModulePage from "./CustomModule/Page";
import CustomTemplatePage from "./CustomTemplate/Page";
import Temp from "./CustomModule/TemplateBuilder";
import NetworkStatus from "./UniversalComponents/NetworkStatus";
import AuthenticationBox from "./AuthenticationBox";
import AiChatBot from "./AIChatbot/AiChatBot";
import Onboarding from "./Onboarding/Onboarding";
import OnboardCompany from "./Onboarding/components/AddCompany/OnboardCompany";
import PermissionHelper from "./Onboarding/components/PermissionHelper";
import ForgetPassword from "./Onboarding/components/ForgetPassword";
import CustomerNewDashboard from "./CustomerNewDashboard";
import { io } from "socket.io-client";
import { useRef } from "react";
import { Dialog } from "@mui/material";
import { useSocket } from "./UniversalComponents/SocketContext";
import ProtectedShell from "./ProtectedShell";
import Workspaces from "./Onboarding/components/Workspaces";
import VendorProfile from "./Vendor/VendorProfile";
import Customization from "./Customize/Customization";
import FormDashboard from "./customer/CustomModule/FormDashboard";
import SettingPage from "./Setting/SettingPage";
import WrappedOnboardCompany from "./Onboarding/components/AddCompany/WrappedOnboardCompany";
// import FormDashboard from "./customer/CustomModule/FormDashboard";
import EmailBuilder from "./EmailBuilder/EmailBuilder";
import EmailBuilderPage from "./EmailBuilder/EmailBuilderPage";
import CombinedWrapper from "./customer/CustomModule/CombinedWrapper";
import { getUserThemeColor } from "../utils/utilityFunctions/localServices";
import GlobalListsDropdownTable from "./GlobalDropdown/GlobalListsDropdownTable";
import ActivityLogWrapper from "./ActivityLogs/AuditLogWrapper";
import CompanyDashboard from "./company/CompanyHome";
import RedirectModulePreview from "./customer/CustomModule/RedirectModulePreview";
import PreviewWrapper from "./customer/CustomModule/PreviewWrapper";

const Body = () => {
  const alert = useSelector((state) => state?.alert?.alert) || {};
  const loading = useSelector((state) => state?.loader?.loading);
  const dispatch = useDispatch();

  const hideAlert = () => {
    dispatch(pushAlert({ type: "", message: "", visible: false }));
  };
  // dispatch(pushAlert({type:"success",message:"You are not logged in",visible:true}))  *** Aakash *** Use this for giving notification
  // dispatch(showLoader())  *** Aakash *** Use this for showing loader
  // dispatch(hideLoader())  *** Aakash *** Use this for Hiding loader

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const { socket, isConnected } = useSocket();
  const [taskPopup, setTaskPopup] = useState(false);

  useEffect(() => {
    if (!socket) return;

    const onConnect = () => {
      console.log("✅ Connected via WebSocket");
    };

    const onNotification = (payload) => {
      // Accept { data: [...] } or a single object
      const next = Array.isArray(payload?.data) ? payload.data : payload?.data ? [payload.data] : [payload];
      setMessages(next);
      setTaskPopup(true);
      {
        console.log(next, "messages aakash");
      }
    };

    const onDisconnect = () => {
      console.log("❌ Disconnected");
    };

    socket.on("connect", onConnect);
    socket.on("notification", onNotification);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("notification", onNotification);
      socket.off("disconnect", onDisconnect);
    };
  }, [socket]);

  useEffect(() => {
    const color = getUserThemeColor();
    console.log("themeCColor kjloo", color);
    document.documentElement.style.setProperty("--color-primary", color);
  }, []);

  const handleCloseTaskPopup = () => {
    setTaskPopup(false);
    setMessages([]);
  };

  return (
    <div className="bg-white h-full">
      {alert && (
        <FirstMessage
          type={alert.type}
          message={alert.message}
          visible={alert.visible}
          onHide={hideAlert}
          showRevert={alert?.showRevert}
          counter={alert?.counter}
          onConfirm={alert?.onConfirm}
          onRevert={alert?.onRevert}
        />
      )}
      {loading && <Loader isOpen={loading} />}
      {/* <NetworkStatus /> */}
      <Router>
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route element={<ProtectedShell />}>
              <Route element={<UserPage />} path="/user" />
              <Route element={<ManagePermission />} path="/manage_permission" />
              <Route element={<ManagePermission />} path="/permission_level/:id" />
              <Route element={<CompanyManagePermission />} path="/company-and-permission" />
              <Route element={<ManageList />} path="/managelist" />
              <Route element={<DynamicListTable />} path="/dynamic/:id" />
              <Route element={<Dashboard />} path="/dashboard" exact />
              <Route element={<Customer />} path="/customers" />
              <Route element={<MySpace />} path="/my_space/*" />

              <Route element={<Invoice />} path="/invoice" />
              <Route element={<TaskPod />} path="/taskPod/:name" />

              <Route element={<RevampledAllTask />} path="/my-activities/:leadTypePath?" />
              <Route element={<RevampledAllTask />} path="/my-assignment/:leadTypePath" />

              <Route element={<TaskTable />} path="/alltasks1/:leadTypePath" />
              <Route element={<AddCustomer />} path="/add_customer" />
              <Route element={<AddCustomer1 />} path="/customer/:id" />
              <Route element={<AddCustomer1 />} path="/customer/:id/:tab/:leadTypePath?" />
              <Route element={<PreviewWrapper />} path="/workspace/record-preview/:leadTypePath" />

              <Route element={<SpecificCustomer />} path="/groupDashboard" />

              <Route element={<AddCompany />} path="/add_company" />
              <Route element={<EditCompany />} path="/edit_company/:id" />
              <Route element={<ModalCompany />} path="/modal_company" />
              <Route element={<Notification />} path="/notification" />
              <Route element={<InvoiceView />} path="/invoice_view" />
              <Route element={<UserProfileDetails />} path="/User_Profile_Details" />
              <Route element={<Importcha />} path="/import_chart_of_account" />
              <Route element={<AssetList />} path="/asset_chart_of_account" />
              <Route element={<CoaForms />} path="/coa_form" />
              <Route element={<Page />} path="/globalfpousa" />
              <Route element={<DashboardMain />} path="/dashboardmain" />
              <Route element={<UserProfileView />} path="/Profile_View" />
              <Route element={<VendorList />} path="/vendor_list" />
              {/* <Route element={<VendorDynamicPage />} path="/vendor" /> */}
              <Route element={<VendorDashboard />} path="/vendor_dashboard/:id" />
              <Route element={<BankTransfer />} path="/bank_transfer" />
              <Route element={<MockPage />} path="/mock_page" />
              {/* <Route element={<AddVendor />} path="/add_vendor" /> */}
              <Route element={<Vendor />} path="/add_vendor" />
              <Route element={<CustomerManagePermission />} path="/company_permission" />
              <Route element={<Expense />} path="/Expense" />
              <Route element={<DynamicVoucherForm />} path="/DynamicVoucher" />
              <Route element={<AutofillBill />} path="/AutofillBills" />

              <Route element={<Checks />} path="/Check" />
              <Route element={<Bills />} path="/Bills" />
              <Route element={<PayBills />} path="/Pay_bills" />

              <Route element={<InvoiceNew />} path="/Invoice_new" />
              {/* Route for Dashboard Funnel  */}

              <Route element={<DashBoardFunnel />} path="/dashboard_funnel" />
              <Route element={<ReceivePayment />} path="/Receive_payment" />
              <Route element={<Statement />} path="/Statement" />
              <Route element={<Estimate />} path="/Estimate" />
              <Route element={<CreditMemo />} path="/Credit_memo" />
              <Route element={<SalesReceipt />} path="/Sales_receipt" />
              <Route element={<ShippingLabel />} path="/Shipping_label" />
              <Route element={<RefundReceipt />} path="/Refund_receipt" />
              <Route element={<DelayedCredit />} path="/Delayed_credit" />
              <Route element={<DelayedCharge />} path="/Delayed_charge" />
              <Route element={<AddClient />} path="/Add_client" />

              <Route element={<PurchaseOrder />} path="/Purchase_order" />
              <Route element={<VendorCredit />} path="/Vendor_credit" />
              <Route element={<CreditCardCredit />} path="/Credit_card_credit" />
              <Route element={<PrintChecks />} path="/Print_checks" />
              <Route element={<VendorAdd />} path="/Vendor_add" />
              <Route element={<JournalEntry />} path="/Journal_entry" />
              <Route element={<AiChatBot />} path="/ai_chat_bot" />
              {/* <Route element={<OnboardCompany />} path="/customize_company" /> hold on to this time */}
              <Route element={<Customization />} path="/customize_company" />
              <Route element={<PermissionHelper />} path="/permissionHelper" />
              <Route element={<Workspaces />} path="/organisations" />
              <Route element={<Vendor addVendor />} path="/add-vendor" />
              <Route element={<Vendor />} path="/vendors" />
              <Route element={<VendorProfile addVendor />} path="/vendor-profile/:id" />
              <Route element={<Vendor editVendor />} path="/edit-vendor" />
              <Route element={<SettingPage />} path="/setting" />
              <Route element={<SettingPage />} path="/setting/:subset" />
              <Route element={<SettingPage />} path="/setting/:subset/:subSubset" />
              <Route element={<ActivityLogWrapper />} path="/audit-log" />
              <Route element={<GlobalListsDropdownTable />} path="/globalListsDropdownTable" />
            </Route>
          </Route>
          {/* test route for emailbuilder */}
          <Route element={<EmailBuilderPage />} path="/email-builder" />
          <Route element={<Test />} path="/test" />
          <Route element={<SignupForm />} path="/signup" />
          <Route element={<ForgetPass />} path="/forget_password" />
          <Route element={<AuthenticationBox />} path="/authentication" />
          {/* <Route element={<ResetPassword />} path="/reset_password/:token/:email" /> */}
          <Route element={<ResetPassword />} path="/reset_password" />
          <Route element={<AddOrganization />} path="/addorganization" />
          <Route element={<VendorDynamicPage />} path="/vendor/:subRoute" />
          <Route element={<GroupDashboard />} path="/groupDashboard" />

          <Route element={<CreateTemplate />} path="/template" />
          <Route element={<CombinedWrapper />} path="/company-module/:leadTypePath" />
          <Route element={<CustomModulePage />} path="/setting/customization/workspace/:id" />
          <Route element={<CustomTemplatePage />} path="/setting/customization/task-template/:id" />

          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Onboarding />} />
          <Route path="/onboarding/:o_stage" element={<Onboarding />} />
          <Route path="/onboard_company" element={<WrappedOnboardCompany />} />
          <Route path="/onboard_company/:subset" element={<WrappedOnboardCompany />} />
          <Route path="/forget_password_one" element={<ForgetPassword />} />
          <Route path="/personSelect" element={<PersonSelect />} />
          <Route path="/customerNewDash" element={<CustomerNewDashboard />} />
          <Route path="/temp" element={<FormDashboard />} />
          <Route path="/companyDashboard" element={<CompanyDashboard />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </div>
  );
};

export default Body;
